module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Upload Files","introduction":[{"full":"To upload files, you can {dragAndDrop} one or more files onto the table on this page.","dragAndDrop":"drag and drop"},{"full":"If you would rather select files from a prompt, ensure that their names match the ones in the table and then {clickHere}.","clickHere":"click here to choose"}]}}')
  delete Component.options._Ctor
}
